import FastMarquee from "react-fast-marquee";

const items = [
    "CENTRAL COAST NSW",
    "POOL CLEANING",
    "REGULAR MAINTENANCE",
    "GREEN POOL RECOVERY",
    "EQUIPMENT CARE",
];

const Marquee = () => (
    <div data-testid="editorial-marquee" className="bg-[#F4F4F0] text-[#03070A] py-5 overflow-hidden select-none">
        <FastMarquee speed={30} gradient={false} pauseOnHover>
            {items.map((item, i) => (
                <span key={i} className="flex items-center">
                    <span className={`mx-8 text-sm md:text-base tracking-[0.15em] whitespace-nowrap ${i % 2 === 0 ? "font-display italic" : "font-semibold uppercase"}`}>
                        {item}
                    </span>
                    <span className="w-1.5 h-1.5 rounded-full bg-[#03070A]/40" />
                </span>
            ))}
        </FastMarquee>
    </div>
);

export default Marquee;
